<template>
  <PaginationRoot
    v-model:page="page"
    :items-per-page="pageMeta?.itemsPerPage ?? 0"
    :total="pageMeta?.totalItems ?? 0"
    :disabled="disabled"
    :siblingCount="1"
    show-edges
  >
    <PaginationList v-slot="{ items }" class="flex items-center justify-center gap-2">
      <PaginationFirst class="btn btn-square btn-neutral max-md:hidden">
        <FontAwesomeIcon :icon="faAngleDoubleLeft" />
      </PaginationFirst>
      <PaginationPrev class="btn btn-square btn-neutral mr-auto max-sm:hidden">
        <FontAwesomeIcon :icon="faChevronLeft" />
      </PaginationPrev>
      <template v-for="(page, index) in items">
        <PaginationListItem
          v-if="page.type === 'page'"
          :key="index"
          :value="page.value"
          class="btn btn-square btn-neutral data-[selected]:btn-primary"
        >
          {{ page.value }}
        </PaginationListItem>
        <PaginationEllipsis
          v-else
          :key="page.type"
          :index="index"
          class="btn btn-square btn-neutral"
          disabled
        >
          <FontAwesomeIcon :icon="faEllipsis" />
        </PaginationEllipsis>
      </template>
      <PaginationNext class="btn btn-square btn-neutral ml-auto max-sm:hidden">
        <FontAwesomeIcon :icon="faChevronRight" />
      </PaginationNext>
      <PaginationLast class="btn btn-square btn-neutral max-md:hidden">
        <FontAwesomeIcon :icon="faAngleDoubleRight" />
      </PaginationLast>
    </PaginationList>
  </PaginationRoot>
</template>

<script setup lang="ts">
import {
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faChevronLeft,
  faChevronRight,
  faEllipsis,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import type { PaginatedMetaDocumented } from '@konsolenkost-de/acquisition_store_server_sdk_vue';
import {
  PaginationEllipsis,
  PaginationFirst,
  PaginationLast,
  PaginationList,
  PaginationListItem,
  PaginationNext,
  PaginationPrev,
  PaginationRoot,
} from 'reka-ui';

defineProps<{
  pageMeta?: PaginatedMetaDocumented;
  disabled?: boolean;
}>();

const page = defineModel<number>('page', { required: true });
</script>
